import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { Validators } from "../../../../../shared/validators";
import { Report, RowActions } from "../../../../admin/report/report";
import { GetFilteredProductsService } from "../../../payment-pages/components/product-management/services/get-filtered-products.service";
import { BuyerInfoReportService } from "../../services/buyer-info-report.service";
import { ReportUpdateTableContentHelper } from "../../services/report-helper.service";

@Component({
  selector: 'app-buyer-info',
  templateUrl: './buyer-info.component.html',
  styleUrls: ['./buyer-info.component.scss']
})
export class BuyerInfoComponent implements OnInit {
  tableColumns: string[] = [];
  displayTableColumns!: any;
  buyerReportData: any[] = [];
  buyerReportDataIds: any[] = [];
  filterField: any[] = [];
  productId = "NULL";
  emptyDataMessage: string =this.constructEmptyProductMessage();
  loading = false;
  requestBody: Report = {};
  rowActions: RowActions[] = [
    {
      actionName: "View",
      actionType: "Button",
      actionClass: "btn-primary"
    }
  ];
  totalNumberOfRecords!: number;
  reportName: string = '';
  colTypes: any;
  clickableColumn: string = '';
  LinkingCoulmns: any;

  constructor(
    public birs: BuyerInfoReportService,
    public productNameService: GetFilteredProductsService,
    private reportContentHelper: ReportUpdateTableContentHelper,
    private router: Router,
    public translate: TranslateService,
  ) { }

  ngOnInit() {
    if (localStorage.getItem('language') === 'ar') {
      this.loadArContent();
    } else {
      this.loadEnContent();
    }
    this.birs.activateLoader();
    this.requestBody.paginationOptions = {
      start: 0,
      limit: 10,
    };
  }

  loadArContent() {
    this.reportName = 'تقرير معلومات المشتري';
    this.translate.use('ar');
    this.prepareArProducts();
  }

  loadEnContent() {
    this.reportName = 'Buyer Info Report';
    this.translate.use('en');
    this.prepareProducts();
  }

  async prepareProducts() {
    this.productNameService.setParams({
      filterOptions: {
        published: "1",
        productType: "any",
        dropDown: true
      },
      sortOptions: {
        productName: "ASC"
      }
    } as Report);
    const result = await this.productNameService.make();
    this.filterField.push({
      filterFieldName: "NewProductId",
      filterDisplayName: "Product",
      defaultValue: "",
      filterOptions: [
        { key: "Please Select", value: "" },
        ...result.map((p: any) => {
          return {
            key: p.productName,
            value: p.id
          };
        })
      ],
      validators: [
        {
          validatorFn: Validators.required,
          message: "Account holder number field is required.*"
        }
      ]
    });
    this.filterField.push({
      filterFieldName: "status",
      filterDisplayName: "Status",
      defaultValue: "",
      filterOptions: [
        { key: "Show All", value: null },
        { key: "CANCELED", value: "CANCELED" },
        { key: "EXPIRED", value: "EXPIRED" },
        { key: "FAILED", value: "FAILED" },
        { key: "NEW", value: "NEW" },
        { key: "PAID", value: "PAID" }
      ]
    });
  }

  async prepareArProducts() {
    this.productNameService.setParams({
      filterOptions: {
        published: "1",
        productType: "any",
        dropDown: true
      },
      sortOptions: {
        productName: "ASC"
      }
    } as Report);
    const result = await this.productNameService.make();
    this.filterField.push({
      filterFieldName: "NewProductId",
      filterDisplayName: "المنتج",
      defaultValue: "",
      filterOptions: [
        { key: "برجاء الإختيار", value: "" },
        ...result.map((p: any) => {
          return {
            key: p.productName,
            value: p.id
          };
        })
      ],
      validators: [
        {
          validatorFn: Validators.required,
          message: "Account holder number field is required.*"
        }
      ]
    });
    this.filterField.push({
      filterFieldName: "status",
      filterDisplayName: "الحالة",
      defaultValue: "",
      filterOptions: [
        { key: "إظهار الكل", value: null },
        { key: "تم الإلغاء", value: "CANCELED" },
        { key: "منتهى الصلاحية", value: "EXPIRED" },
        { key: "باءت بالفشل", value: "FAILED" },
        { key: "جديد", value: "NEW" },
        { key: "مدفوع", value: "PAID" }
      ]
    });
  }

  async rowActionClicked(event: any) {
    this.router.navigate(["/seller/reports/buyerInfoReport/details/" + event.key.id]);
  }

  async filter(event: any) {
    if (event && Object.keys(event).length) {
      this.requestBody.filterOptions = event;
      if (event.productId) {
        this.productId = event.productId;
      }
    } else {
      this.requestBody.filterOptions = {};
    }
    this.requestBody.paginationOptions = {
      start: 0,
      limit: 10
    };
    await this.updateTable();
    this.birs.loader().subscribe((val: any) => (this.loading = val));
  }

  async paginate(event: any) {
    this.requestBody.paginationOptions = {
      start: event.pageIndex * event.pageSize,
      limit: event.pageSize
    };
    this.updateTable();
    this.birs.loader().subscribe((val: any) => (this.loading = val));
  }

  async updateTable() {
    try{
    this.birs.activateLoader();
    this.loading = true;
    this.birs.setParams(this.requestBody);
    const result = await this.birs.make();
    this.formatHeaders(result?.headers || []);

    this.buyerReportData = result?.result || [];
    this.buyerReportDataIds = this.buyerReportData?.map(data => data.id) ||[];
    var monthe = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    this.buyerReportData = this.buyerReportData.map(p => {
      let keys = Object.keys(p);
      for (let key of keys) {
        if (key == 'id' || !p[key]) continue; // don't mangle the id
        let date = new Date(p[key]);
        if (date.getDate() && p[key].toString().length >= 24) {
          let time = p[key].toString().match(/[0-9]+:[0-9]+$/);
          p[key] = `${time ? time[0] : ''} ${monthe[date.getMonth()]} ${date.getDate()} , ${date.getFullYear()}`;
        }
      }
      return p;
    });

    this.reportContentHelper.pushTableContent({
      tableColumns: this.tableColumns,
      displayTableColumns: this.displayTableColumns,
    });
    this.emptyDataMessage = '';
    this.totalNumberOfRecords = result?.totalNumberOfRows || 0;
    this.loading = false;
    }catch(err){
      this.loading = false;

    }
  }

  formatHeaders(headersArray: string[]) {
    this.tableColumns = headersArray;
    this.displayTableColumns = {};
    for (const head of headersArray) {
      this.displayTableColumns[head] = head;
    }
  }

  async searchChange(event: any) {
    if (event) {
      this.requestBody.searchOptions = {
        searchKey: event,
      };
    } else {
      this.requestBody.searchOptions = undefined;
      this.birs.loader().subscribe((val: any) => (this.loading = val));
    }
    await this.updateTable();
  }

  async sortChange(event: any) {
    if (event.direction === "") {
      this.requestBody.sortOptions = {};
    } else {
      this.requestBody.sortOptions = {
        [`${event.active}`]: event.direction
      };
    }
    await this.updateTable();
    this.birs.loader().subscribe((val: any) => (this.loading = val));
  }
  private constructEmptyProductMessage(){
    return "Please select a product first!";
  }
}
